<template>
  <InfuseTag :variant="variant" size="md">
    {{ t(`iam.access-requests.status.${status.toLowerCase()}`) }}
  </InfuseTag>
</template>

<script setup lang="ts">
import { AccessRequestStatus } from '@infuse/api/iam/access-request';
import { InfuseTag } from '@infuse/ui/components';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
  status: AccessRequestStatus;
}>();

const variant = computed(() => {
  switch (props.status) {
    case AccessRequestStatus.PENDING:
      return 'warning';
    case AccessRequestStatus.APPROVED:
      return 'success';
    case AccessRequestStatus.DENIED:
      return 'error';
    case AccessRequestStatus.CANCELLED:
    default:
      return 'neutral';
  }
});
</script>
